import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Header } from "./components/layout/Header";
import { Footer } from "./components/layout/Footer";
import { HeroSection } from "./components/sections/HeroSection";
import { BenefitsSection } from "./components/sections/BenefitsSection";
import { AboutSection } from "./components/sections/AboutSection";
import { CreditsSection } from "./components/sections/CreditsSection";
import { ProcessSection } from "./components/sections/ProcessSection";
import { FAQSection } from "./components/sections/FAQSection";
import { ContactSection } from "./components/sections/ContactSection";
import { UNESection } from "./components/sections/UNESection";
import { CTASection } from "./components/sections/CTASection";
import { PrivacyPolicyPage } from "./pages/PrivacyPolicyPage";
import WhatsAppButton from "./components/ui/WhatsAppButton";

const LandingPage = () => {
  return (
    <div className="min-h-screen font-['Inter',sans-serif]">
      <Header />
      <main>
        <HeroSection />
        <CreditsSection />
        <BenefitsSection />
        <AboutSection />
        <ProcessSection />
        <FAQSection />
        <ContactSection />
        <UNESection />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/aviso-de-privacidad" element={<PrivacyPolicyPage />} />
        </Routes>
        <WhatsAppButton />
      </BrowserRouter>
    </div>
  );
}

export default App;
